import { className } from 'lib/css'
import { useCallback } from 'preact/hooks'

export default function CarouselPagination({
  items,
  currentIndex,
  onChange,
  getItemKey,
  getItemLabel,
}) {
  const itemCount = items.length
  const handlePaginate = useCallback(
    (event) => {
      const slideIndex = Number(event.target.dataset.item || '0')
      const nextIndex = Math.min(itemCount - 1, Math.max(0, slideIndex))
      if (nextIndex !== currentIndex) {
        onChange(nextIndex)
      }
    },
    [itemCount, currentIndex, onChange],
  )

  return (
    <div className={className('carousel-pagination__wrapper')} role="group">
      <ul className={className('carousel-pagination')}>
        {items.map((item, idx) => {
          const isActive = currentIndex === idx
          return (
            <li
              key={getItemKey(item, idx, 'pagination-item-')}
              className={className(
                'carousel-pagination__item',
                isActive ? 'is-active' : undefined,
              )}
            >
              <button
                className={className('carousel-pagination__button')}
                type="button"
                onClick={handlePaginate}
                data-item={idx}
                aria-disabled={isActive ? 'true' : undefined}
                aria-label={getItemLabel(item, idx)}
              />
            </li>
          )
        })}
      </ul>
    </div>
  )
}
